import { render, staticRenderFns } from "./joke.vue?vue&type=template&id=31f90dd1&"
import script from "./joke.vue?vue&type=script&lang=js&"
export * from "./joke.vue?vue&type=script&lang=js&"
import style0 from "./joke.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports